import { z } from "zod";
import { podpisBase64Schema } from "./hca-prihlasky";

/**
 * HCA Moravia — kiosk check-in schemas (plán §S.5).
 *
 * Kiosk je tablet režim pro odbavení účastníků ráno před seminářem.
 * Admin vygeneruje signed JWT token přes generateKioskToken a dá URL
 * do tabletu. Token má omezenou platnost (default 8h).
 */

const uuidMsg = "Neplatné UUID";

/** Admin mutation — vygeneruje signed URL pro tablet. */
export const generateKioskTokenSchema = z.object({
  terminId: z.string().uuid(uuidMsg),
  ttlMinutes: z
    .number()
    .int("Minuty musí být celé číslo")
    .min(30, "Minimálně 30 minut")
    .max(720, "Maximálně 12 hodin")
    .default(480),
});

/** Public query — seznam účastníků pro daný kiosek token. */
export const listKioskAttendeesSchema = z.object({
  token: z.string().min(10, "Token je povinný").max(2000, "Token je příliš dlouhý"),
});

/** Public mutation — potvrzení check-inu na tabletu. */
export const kioskCheckinSchema = z.object({
  token: z.string().min(10).max(2000),
  prihlaskaId: z.string().uuid(uuidMsg),
  gdprConsent: z.literal(true),
  fotoConsent: z.coerce.boolean().default(false),
  // Stejná tvrdá validace jako u přihlášky: PNG-magic + base64 charset + 200 kB
  // strop. Brání POSTu libovolného 500kB textu na neautentizovaný endpoint.
  podpisBase64: podpisBase64Schema.optional(),
});

export type GenerateKioskTokenInput = z.infer<typeof generateKioskTokenSchema>;
export type ListKioskAttendeesInput = z.infer<typeof listKioskAttendeesSchema>;
export type KioskCheckinInput = z.infer<typeof kioskCheckinSchema>;
